import { render } from "./orderServeTmp.vue?vue&type=template&id=4d56d4c8"
import script from "./orderServeTmp.vue?vue&type=script&lang=js"
export * from "./orderServeTmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__